import { useLoadPrebuiltLayoutSections } from 'ducks/layoutSections/hooks'

const PrebuiltLayoutSectionsLoader = (): null => {
  useLoadPrebuiltLayoutSections()

  return null
}

export default PrebuiltLayoutSectionsLoader
